import { render, staticRenderFns } from "./AmBusy.vue?vue&type=template&id=ac620cb6&scoped=true"
import script from "./AmBusy.vue?vue&type=script&lang=js"
export * from "./AmBusy.vue?vue&type=script&lang=js"
import style0 from "./AmBusy.vue?vue&type=style&index=0&id=ac620cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac620cb6",
  null
  
)

export default component.exports